const SECTORS = [
  { icon: "account_balance", label: "Banking & Finance" },
  { icon: "medical_services", label: "Healthcare" },
  { icon: "bolt", label: "Energy & Infrastructure" },
  { icon: "account_balance", label: "Government & Telecom" },
  { icon: "shopping_cart", label: "Retail & E-commerce" },
  { icon: "memory", label: "Technology & SaaS" },
];

function Row() {
  return (
    <div className="flex items-center gap-12 font-label-sm text-label-sm text-on-surface-variant dark:text-surface-variant uppercase tracking-widest">
      {SECTORS.map((s) => (
        <span key={s.label} className="flex items-center gap-2 shrink-0">
          <span className="material-symbols-outlined text-[18px]">{s.icon}</span>
          {s.label}
        </span>
      ))}
    </div>
  );
}

export default function TrustMarquee() {
  return (
    <section className="w-full py-12 border-y border-glass bg-surface-bright dark:bg-surface-dark overflow-hidden mb-section-gap">
      <div className="flex items-center gap-12 whitespace-nowrap animate-marquee opacity-60">
        <Row />
        <Row />
      </div>
    </section>
  );
}
